import dayjs from 'dayjs';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { SeparatorLine } from '../../../components/SeparatorLine/SeparatorLine';
import { useLanguage } from '../../../locale/useLanguage';
import { Article } from '../../../models';
import { Routes } from '../../../routes/types';

import './NewsRow.css';

type NewsRowProps = {
  article: Article;
};

export const NewsRow: React.FC<NewsRowProps> = ({ article }) => {
  const [t] = useLanguage();
  const history = useHistory();
  const formattedDate = dayjs(article.published_at).format('DD MMM YYYY');

  const goToNewsDetails = useCallback(() => {
    history.push(Routes.NewsDetails.replace(':newsId', `${article.id}`));
  }, [article.id, history]);

  return (
    <>
      <a role="link" onClick={goToNewsDetails} className="news-row--container">
        <div className="news-row--topic-row">
          <p className="news-row--topic">{t('news.pressRelease')}</p>
          <p className="paragraph news-row--date">{formattedDate}</p>
        </div>
        <h3 className="subtitle">{article.title}</h3>
        <div className="news-row--description-container">
          <p className="news-row--description">{article.description}</p>
        </div>
      </a>
      <SeparatorLine />
    </>
  );
};
